import { types } from 'mobx-state-tree';

import { IsoDate } from '../../../common/v1';

import { ReferralTypeEnum } from '../definitions/ReferralType';
import LOCK_STATES, { LockStateEnum } from '../definitions/LockState';
import { SubmissionSourceEnum } from '../definitions/SubmissionSource';
import { ValidationStateEnum } from '../definitions/ValidationState';


const Metadata = types.model('Metadata', {
    createdDate: types.optional(IsoDate, new Date()),
    referral: types.maybe(ReferralTypeEnum),
    referrer: types.maybe(types.string),
    userAgent: types.maybe(types.string),
    lastEditDate: types.maybe(IsoDate),
    lastEditDateClient: types.maybe(IsoDate),
    lastEditDateAgent: types.maybe(IsoDate),
    lastEditUser: types.maybe(types.string),
    lockState: types.optional(LockStateEnum, LOCK_STATES.UNLOCKED),
    lockStateIClarify: types.optional(LockStateEnum, LOCK_STATES.UNLOCKED),
    salesforceID: types.maybe(types.string),
    filogixID: types.maybe(types.string),
    isAppCa: types.optional(types.boolean, true),
    startedWithUnifiedDoc: types.optional(types.boolean, true),
    deleted: types.optional(types.boolean, false),
    isFromAgentLink: types.maybe(types.boolean),
    validation: types.map(ValidationStateEnum),
    isConverted: types.optional(types.boolean, false),
    lastVisitedSection: types.maybe(types.string),
    // keep it as .maybe allows us to detect documents without this newer field
    documentSource: types.maybe(SubmissionSourceEnum),
    googleDriveFolder: types.maybe(types.string),
});

export default Metadata;
